<template>
    <div class="row mx-0 cart-option-button prz-select" :class="{ 'no-default' : !selected, 'lock-cursor' : disableInput, 'col': !open || optionType == 'qty', 'col-12 expand': open && optionType != 'qty' }" @click="open = !open">
        <span :for="'select-' + optionType" class="label-btn"> {{ label }} </span>
        <!--<i :class="open ? 'ecom-chevron-top' : 'ecom-chevron-down'"/>-->
        <i :class="{'open': open}" class="ecom-chevron-down"/>
        <div
                v-if="optionType != 'qty'"
                class="custom-select" 
                :class="{open: open, 'no-sel-active' : !defaultValue && emptySelectionWarning, 'disabled' : disableInput }" 
                @blur="open = false" 
                :tabindex="tabindex"
                :ref="'select-' + optionType"
                :name="'select-' + optionType"
                :id="'select-' + optionType"
        >
            <div class="selected" :class="{'open': open}"> {{ selectedDescription }} </div>
            <ul class="items" :class="{'list-hide': !open}">
                <li
                        v-for="(option, index) of options"
                        :key="option.id"
                        :value="option.id"
                        :data-id="option.id"
                        :data-order="index"
                        :data-isdefaultsku="option.default"
                        class="item"
                        @click= "option != selected ? getOptionObj(option) : !open"
                >
                    <p>
                        {{ option.stock ? option.description : option.description + ' - ' + kStrings.kPROD_STOCK_OUT }}
                    </p>
                    <i v-if="selected == option" class="ecom-check"/>
                </li>
            </ul>
        </div>
        <div
                v-else
                class="custom-select"
                :class="{open: open, 'no-sel-active' : !defaultValue && emptySelectionWarning, 'disabled' : disableInput}"
                @blur="open = false"
                :tabindex="tabindex"
                :ref="'select-' + optionType"
                :name="'select-' + optionType"
                :id="'select-' + optionType"
        >
            <div class="selected" :class="{open: open}"> {{ selected }} </div>
            <ul class="items" :class="{'list-hide': !open}">
                <li
                        v-for="n in getNumbers(1, this.qtyLimit)"
                        :key="n" 
                        :value="n"
                        @click="setQtyInput(n)"
                        class="item"
                >
                    <p>
                        {{n}}
                    </p>
                    <i v-if="selected == n" class="ecom-check"/>
                </li>
            </ul>
            
        </div>
        
    </div>
</template>

<script>
    import {bus} from '@/store/bus';
    import {isEmpty} from 'lodash-es';
    
    export default {
        name: 'SelectBtnCustom',
        components: {},
        props: {
            label: String,
            options: Array,
            value: Object,
            optionType: String,
            optionsInStock: Array,
            kStrings: Object,
            tabindex: {
                type: Number,
                required: false,
                default: 0
            },
            defaultValue: {
                type: Object,
                default: null,
            },
            disableInput: {
                type: Boolean,
                default: false,
            },
            currentSelection: String,
            itemIndex: { // for multiple widgets
                type: Number,
                default: 0,
            },
            qtyLimit: {
                type: Number,
                default: 5,
            },
            emptySelectionWarning: {
                type: Boolean,
                default: false,
            },
        },
        data: function() {
            return {
                selected: this.defaultValue ? this.defaultValue : ( this.optionType != 'qty' ? null : 1 ),
                open: false,
            };
        },
        computed: {
            selectedDescription() {
                if(!this.selected) {
                    return null;
                }
                
                return this.selected.stock ? this.selected.description : this.selected.description + ' - ' + this.kStrings.kPROD_STOCK_OUT
            }
        },
        methods: {
            getOptionObj: function(option, single = false) {
                //if (this.optionType != 'qty') {
                    this.selected = option;
                    this.$emit('input', this.selected);
                    if(!single) {
                        bus.$emit('update-cart-option', this.currentSelection);
                    }
                    //return option;
              /*  }*/
                
                //return 1;
                //return this.options.find(option => option.id == varId);
            },

            // for qty selects
            getNumbers: function(start, stop) {
                stop += 1;
                return new Array(stop - start).fill(start).map((n, i) => n + i);
            },

            setQtyInput: function(qty) {
               // this.open = false;
                this.selected = qty;
                bus.$emit('empty-selection-warning', false);
                bus.$emit('update-cart-qty', qty);
            },
        },
        watch: {
            options(newValue, oldValue){
                if(newValue) {
                    if(this.selected && JSON.stringify(this.defaultValue) != JSON.stringify(this.selected)){
                        let sel = Object.assign({}, this.selected);
                        newValue.forEach(element => {
                            if(element.id == sel.id){
                                this.getOptionObj(element);
                            }
                        });
                    }
                    
                    if(this.selected && isEmpty(newValue.filter(elem => elem.id == this.selected.id))) {
                        this.selected = null; // selection widget is already with the correct value
                    }
                    
                }
            }
        },
        created() {
            this.$emit('input', this.value);
            bus.$on('update-single-select', () => {
                if(this.options && this.optionType != 'qty') {
                    this.selected = this.options[0]; // cursed computed vars
                    this.getOptionObj(this.options[0], true);
                }
            });
            
            bus.$on('set-qty-input', (value) => {
                if(this.optionType == 'qty') {
                    this.setQtyInput(value);
                }
            });
            
            /*bus.$on('get-option-obj', (option) => {
                this.$emit('input', this.getOptionObj(option))
            });*/
        },
        mounted() {
            this.$nextTick(() => {
                if (this.defaultValue) {
                    this.$emit('input', this.defaultValue);
                }

                if(this.options && this.options.length == 1) {
                    this.getOptionObj(this.options[0], true);
                }
            });
            /* this.$emit('input', this.selected);*/
        },
    };
</script>

<style module>

</style>